module.exports = __webpack_public_path__ + "img/yalda-report.df9dfea.png";